import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
import { Spacer, Container, Row, Col } from '@cleartrip/bento/lib';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "box-sizing"
    }}>{`Box Sizing`}</h1>
    <p>{`Sets how the total width and height of an element is calculated.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.bs-content</Name>
    <Output mdxType="Output">box-sizing: content-box;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bs-border</Name>
    <Output mdxType="Output">box-sizing: border-box;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bs-unset</Name>
    <Output mdxType="Output">box-sizing: unset;</Output>
  </Property>
    </Reference>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`This example explains `}<inlineCode parentName="p">{`content-box`}</inlineCode>{` `}<strong parentName="p">{`without`}</strong>{` and `}<strong parentName="p">{`with`}</strong>{` `}<inlineCode parentName="p">{`padding`}</inlineCode>{` and `}<inlineCode parentName="p">{`border`}</inlineCode></p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block bg-tertiary-300 m-5 ba bc-tertiary-700">
        <p className="c-white p-4 ta-center">Parent container</p>
        <div className="bg-tertiary-500 w-100p bs-content">
          <p className="c-white ta-center">Child container</p>
        </div>
    </div>
    <div className="d-inline-block bg-tertiary-300 m-5 ba bc-tertiary-700">
        <p className="c-white p-4 ta-center">Parent container</p>
        <div className="bg-tertiary-500 w-100p ba bc-tertiary-700 bs-content p-2">
          <p className="c-white ta-center">Child container</p>
        </div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="box-content">...</p>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={4} mdxType="Spacer" />
    <p>{`This example explains `}<inlineCode parentName="p">{`border-box`}</inlineCode>{` `}<strong parentName="p">{`without`}</strong>{` and `}<strong parentName="p">{`with`}</strong>{` `}<inlineCode parentName="p">{`padding`}</inlineCode>{` and `}<inlineCode parentName="p">{`border`}</inlineCode></p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block bg-tertiary-300 m-5 ba bc-tertiary-700">
        <p className="c-white p-4 ta-center">Parent container</p>
        <div className="bg-tertiary-500 w-100p bs-border">
            <p className="c-white ta-center">Child container</p>
        </div>
    </div>
    <div className="d-inline-block bg-tertiary-300 m-5 ba bc-tertiary-700">
        <p className="c-white p-4 ta-center">Parent container</p>
        <div className="bg-tertiary-500 w-100p ba bc-tertiary-700 box-border p-2">
          <p className="c-white ta-center">Child container</p>
        </div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="box-border">...</p>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      